import { Grid, useMediaQuery } from "@mui/material";
import { dripOfferAssets } from "assets/cdn";
import { useEnvContext } from "contexts";
import { IShopRewardItem } from "contexts/WebStoreProvider/types";
import { FeaturesFlags } from "helpers";
import { useAppSelector, useImagePath } from "hooks";
import useBreakpoints from "hooks/useBreakpoints";
import { PurchaseOfferSingleItem } from "interfaces";
import { LoyaltyPoints, Tiki } from "pages/DripOffer/styles";
import { selectPoisBountyV3State } from "redux/slices";
// import { CardFinalMessage } from "styles/general_styles";
import { LoyaltyPointsV2 } from "styles/general_styles";
import { CrownIcon, CrownIconV2 } from "utils/svgIcons";

interface OfferProps {
	firstOffer:
		| {
				offer: PurchaseOfferSingleItem;
				items: IShopRewardItem[];
		  }
		| undefined;
	isPopup?: boolean;
}

export const Offer = ({ firstOffer, isPopup }: OfferProps) => {
	const { isSmDown, isMdUp } = useBreakpoints();
	const { isFeatureFlagEnabled } = useEnvContext();
	const isSmall = useMediaQuery("(max-width: 754px)");
	const isPortrait = useMediaQuery("(orientation: portrait)");
	const { canContribute: isPoisActive } = useAppSelector(
		selectPoisBountyV3State
	);
	const { getImage } = useImagePath("cdn");
	const tikiImage = getImage(dripOfferAssets.tiki);

	if (!isPopup) {
		return (
			<>
				{isMdUp && (
					<Grid item xs={12} zIndex={1}>
						<Grid item>
							<h3>Get this now:</h3>
						</Grid>
					</Grid>
				)}
				<Grid item xs={12} zIndex={1} mx="auto" position="relative">
					<Tiki src={tikiImage} alt="Tiki saying hi" />
					<Grid container className="ticket">
						{isSmDown && (
							<Grid item xs={12}>
								<h3 className="mobile">Get this now:</h3>
							</Grid>
						)}
						<Grid
							item
							xs={5}
							lg={5}
							position="relative"
							display="flex"
							justifyContent="center"
							alignItems="center"
						>
							<div className="item-background" />
							<div className="item-content large">
								<img src={firstOffer?.items[0]?.imageUrl} alt="" />
								<p
									className={`large ${
										firstOffer?.items?.[0]?.id === "coin" && "is-coin"
									}`}
								>
									{firstOffer?.items[0]?.value?.toLocaleString("en-US")}
								</p>
							</div>
						</Grid>
						<Grid
							item
							xs={2}
							lg={2}
							className="plus"
							display="flex"
							justifyContent="center"
							alignItems="center"
						>
							+
						</Grid>
						<Grid
							item
							xs={5}
							lg={5}
							position="relative"
							display="flex"
							justifyContent="center"
							alignItems="center"
						>
							<div className="item-background" />
							<div className="item-content large">
								<img src={firstOffer?.items[1]?.imageUrl} alt="" />
								<p
									className={`large ${
										firstOffer?.items?.[1]?.id === "coin" && "is-coin"
									}`}
								>
									{firstOffer?.items[1]?.value?.toLocaleString("en-US")}
								</p>
							</div>
						</Grid>
						<Grid item mt={"2px"} mx="auto">
							{isFeatureFlagEnabled(FeaturesFlags.UI_V2) ? (
								<LoyaltyPointsV2 padding="0.2em 1em" fontSize="1em">
									<div>
										Earn <CrownIconV2 width={15} height={15} />{" "}
										{firstOffer?.offer.loyaltyPointReward?.toLocaleString(
											"en-US"
										)}
									</div>
									{/*
										{isPoisActive && (
											<CardFinalMessage color="#FBBD05">
												Contribute to Poi’s Bounty
											</CardFinalMessage>
										)}
									*/}
								</LoyaltyPointsV2>
							) : (
								<LoyaltyPoints>
									<div>
										Earn <CrownIcon />{" "}
										{firstOffer?.offer.loyaltyPointReward?.toLocaleString(
											"en-US"
										)}
									</div>
									{/*
										{isPoisActive && (
											<CardFinalMessage color="#FBBD05">
												Contribute to Poi’s Bounty
											</CardFinalMessage>
										)}
									*/}
								</LoyaltyPoints>
							)}
						</Grid>
					</Grid>
				</Grid>
				<Grid item xs={12} zIndex={1} mx="auto">
					<Grid item xs={12} mx="auto">
						<h3>Claim a new prize each day you login:</h3>
					</Grid>
				</Grid>
			</>
		);
	} else {
		return (
			<>
				<Grid item xs={12} sm={12} mx="auto">
					{(!isPortrait || !isSmall) && (
						<Grid item sm={12} mx="auto">
							<h3>Get this now:</h3>
						</Grid>
					)}
				</Grid>
				<Grid item xs={12} sm={12} mx="auto" position="relative">
					<Tiki src={tikiImage} alt="Tiki saying hi" isPopup={true} />
					<Grid container className="ticket" alignItems="center">
						{isPortrait && isSmall && (
							<Grid item xs={12}>
								<h3 className="mobile isPopup">Get this now:</h3>
							</Grid>
						)}
						<Grid
							item
							xs={5}
							sm={5.2}
							position="relative"
							display="flex"
							justifyContent="center"
							alignItems="center"
						>
							<div className="item-background" />
							<div
								className={`item-content large ${
									isPoisActive && "isPoisActive"
								}`}
							>
								<img src={firstOffer?.items[0]?.imageUrl} alt="" />
								<p
									className={`large ${
										firstOffer?.items?.[0]?.id === "coin" && "is-coin"
									}`}
								>
									{firstOffer?.items[0]?.value?.toLocaleString("en-US")}
								</p>
							</div>
						</Grid>
						<Grid
							item
							xs={2}
							sm={1.6}
							className={`plus ${isPoisActive && "isPoisActive"}`}
							textAlign="center"
						>
							+
						</Grid>
						<Grid
							item
							xs={5}
							sm={5.2}
							position="relative"
							display="flex"
							justifyContent="center"
							alignItems="center"
						>
							<div className="item-background" />
							<div
								className={`item-content large ${
									isPoisActive && "isPoisActive"
								}`}
							>
								<img src={firstOffer?.items[1]?.imageUrl} alt="" />
								<p
									className={`large ${
										firstOffer?.items?.[1]?.id === "coin" && "is-coin"
									}`}
								>
									{firstOffer?.items[1]?.value?.toLocaleString("en-US")}
								</p>
							</div>
						</Grid>
						<Grid item mt={0.5} mx="auto">
							{isFeatureFlagEnabled(FeaturesFlags.UI_V2) ? (
								<LoyaltyPointsV2 padding="4px 1em" fontSize="12px">
									<div>
										Earn{" "}
										<CrownIconV2 width={isPoisActive ? 12 : 16} height="auto" />{" "}
										{firstOffer?.offer.loyaltyPointReward?.toLocaleString(
											"en-US"
										)}
									</div>
									{/*
										{isPoisActive && (
											<CardFinalMessage color="#FBBD05">
												Contribute to Poi’s Bounty
											</CardFinalMessage>
										)}
									*/}
								</LoyaltyPointsV2>
							) : (
								<LoyaltyPoints className={`${isPoisActive && "isPoisActive"}`}>
									<div>
										Earn <CrownIcon width={isPoisActive ? 12 : 16} />{" "}
										{firstOffer?.offer.loyaltyPointReward?.toLocaleString(
											"en-US"
										)}
									</div>
									{/*
										{isPoisActive && (
											<CardFinalMessage color="#FBBD05">
												Contribute to Poi’s Bounty
											</CardFinalMessage>
										)}
									*/}
								</LoyaltyPoints>
							)}
						</Grid>
					</Grid>
				</Grid>
			</>
		);
	}
};
